// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__34BZu","signatureButtonsRight":"ModalSign_signatureButtonsRight__2IdMX"};